// extracted by mini-css-extract-plugin
export default {"GitHubAvatar":"AssigneeVisual-module__GitHubAvatar--gUHvy"};